<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-title v-if="!onlyAppointments" class="pa-0 pa-md-4">
          <v-switch
            v-model="isCategoryMode"
            :loading="categoryModeLoading"
            dense
            hide-details
            inset
            @click="handleCategoryMode(isCategoryMode)"
          >
            <template v-slot:label>
              <div class="break-word text-right">دسته‌بندی تاریخ‌‌ها</div>
            </template>
          </v-switch>
        </v-card-title>

        <edit-appointment-category
          v-if="isCategoryMode && !onlyAppointments"
          v-model="computedValue"
          :categories.sync="computedValue[this.getItemsReservations]"
          @fetch="getCategories"
        />

        <template v-else>
          <v-card
            v-for="(date, index) in computedValue[this.getItemsReservations]"
            :key="index"
            class="mt-2 rounded-lg d-flex pa-4 align-center"
            @click="editDates(index)"
          >
            <div>
              <!--            <img :src="date.photoBackground" alt="" class="rounded-lg me-2" width="48px">-->
              ویرایش تاریخ
              <v-btn class="ms-1" outlined>{{ date.text }}</v-btn>
            </div>

            <v-spacer />
            <v-btn icon max-width="36" @click.stop="deleteDate(date, index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-icon class="d-none d-md-block"
              >mdi-cursor-default-click-outline</v-icon
            >
          </v-card>
        </template>

        <custom-popup
          v-model="dialog"
          :close-on-confirm="false"
          :cons="cons"
          max-height="80vh"
          max-width="1024"
          reloadable
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-edit-data`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن/ ویرایش تاریخ و نوبت‌ها"
            />
          </template>
          <v-card
            :loading="loading"
            class="dialog-content pa-4"
            flat
            min-height="50vh"
          >
            <v-row no-gutters>
              <v-col class="pa-2" cols="12">
                <div class="rowinfo">
                  <custom-date-picker
                    v-model="dates"
                    :auto-submit="false"
                    :disable="
                      computedValue[this.getItemsReservations].map(
                        (item) => item.value
                      )
                    "
                    :max="maxDate"
                    format="date"
                    label="انتخاب تاریخ‌ها"
                    multiple
                    :min="minDate"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    sortable
                    class="contentinfo"
                  >
                    <template v-slot:default="{ inputClass }">
                      <v-combobox
                        v-model="computedDate"
                        :class="inputClass"
                        chips
                        class="rounded-lg"
                        dense
                        hint="برای انتخاب تاریخ‌ها کافیست روی تاریخ‌های انتخابی خود کلیک نمایید."
                        label="انتخاب تاریخ‌ها"
                        multiple
                        outlined
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        return-object
                        small-chips
                      />
                    </template>
                  </custom-date-picker>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-show-maxdate`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="انتخاب تاریخ‌ها"
                  />
                </div>
              </v-col>

              <template v-for="(item, i) in shiftTimes">
                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <custom-date-picker
                      v-model="item.start"
                      :input-class="`start-time-${i}`"
                      class="rounded-lg contentinfo"
                      dense
                      expression="HH:mm"
                      format="time"
                      hint="ساعت شروع اولین نوبت را انتخاب نمایید."
                      label="ساعت شروع"
                      nullable
                      outlined
                      persistent-hint
                      prepend-inner-icon="mdi-clock-outline"
                      readonly
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-item-start`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="ساعت شروع"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="5">
                  <div class="rowinfo">
                    <custom-date-picker
                      v-model="item.end"
                      :input-class="`end-time-${i}`"
                      :min="item.start"
                      class="rounded-lg contentinfo"
                      dense
                      expression="HH:mm"
                      format="time"
                      hint="ساعت آخرین نوبت را انتخاب نمایید."
                      label="ساعت پایان"
                      nullable
                      outlined
                      persistent-hint
                      prepend-inner-icon="mdi-clock-outline"
                      readonly
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-item-end`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="ساعت پایان"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2 text-center" cols="12" md="1">
                  <div class="rowinfo">
                    <div class="contentinfo">
                      <p class="d-md-none ma-0">افزودن/حذف شیفت</p>
                      <v-btn
                        v-if="shiftTimes.length > 1"
                        class="rounded-lg me-1"
                        color="red"
                        icon
                        outlined
                        small
                        @click="shiftTimes.splice(i, 1)"
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="
                          i + 1 === shiftTimes.length && shiftTimes.length <= 2
                        "
                        class="rounded-lg ma-0"
                        color="green"
                        icon
                        outlined
                        small
                        @click="addShift"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-remove-add-shift`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="افزودن/حذف شیفت"
                    />
                  </div>
                </v-col>
              </template>

              <v-col class="pa-2" cols="12" md="6">
                <div class="rowinfo">
                  <v-text-field
                    v-model="title"
                    class="rounded-lg contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hint="عنوان نوبت‌ها"
                    label="عنوان"
                    outlined
                    persistent-hint
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-item-title`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان"
                  />
                </div>
              </v-col>

              <v-col class="pa-2" cols="12" md="6">
                <div class="rowinfo">
                  <v-text-field
                    v-model="interval"
                    class="rounded-lg contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hint="فاصله بین هر نوبت چند دقیقه باشد؟"
                    label="فاصله بین نوبتها (دقیقه)"
                    min="1"
                    outlined
                    persistent-hint
                    type="number"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-interval`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="فاصله بین نوبتها (دقیقه)"
                  />
                </div>
              </v-col>

              <v-col class="pa-2" cols="12" md="6">
                <div class="rowinfo">
                  <v-text-field
                    v-model="count"
                    class="rounded-lg contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hint="حداکثر تعداد نوبت در هر تاریخ را وارد نمایید."
                    label="تعداد نوبتها"
                    min="1"
                    outlined
                    persistent-hint
                    type="number"
                  /><help-info
                    :element-name="`${serviceName}-${componentName}-count`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="تعداد نوبتها"
                  />
                </div>
              </v-col>

              <v-col class="pa-2" cols="12" md="6">
                <div class="rowinfo">
                  <price-input
                    v-model="price"
                    class="rounded-lg contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hint="لطفا هزینه هر نوبت را به ریال وارد نمایید."
                    label="مبلغ هر نوبت (ریال)"
                    min="1"
                    outlined
                    persistent-hint
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-price`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="مبلغ هر نوبت (ریال)"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </custom-popup>

        <custom-popup
          v-model="createCategoryDialog"
          :cons="{ title: 'افزودن دسته‌بندی جدید' }"
          hide-confirm
          max-width="640"
        >
          <v-card flat>
            <v-card-text>
              <div class="rowinfo">
                <v-text-field
                  v-model="tempCategory.name"
                  class="rounded-lg contentinfo"
                  clearable
                  dense
                  hide-details
                  label="نام دسته‌بندی"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempCategory-name`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="نام دسته‌بندی"
                />
              </div>

              <pic-selector
                :edit-name="false"
                :field.sync="tempCategory.picture"
                one-pic
                single
              />

              <v-radio-group
                v-if="
                  !isCategoryMode &&
                  !!computedValue[this.getItemsReservations] &&
                  !!computedValue[this.getItemsReservations].length
                "
                v-model="tempCategory.old_appointments"
                hide-details
              >
                <template v-slot:label>
                  <div class="text-right">
                    برای تغییر به حالت دسته‌بندی، لطفا یک گزینه را انتخاب
                    نمایید:
                  </div>
                </template>
                <v-radio
                  label="افزودن نوبت‌های موجود به دسته‌بندی"
                  value="make-group"
                />
                <v-radio
                  label="حذف نوبت‌های ساخته شده از قبل"
                  value="remove-items"
                />
              </v-radio-group>
            </v-card-text>

            <v-card-actions>
              <div
                class="rowinfo"
                style="width: 100% !important"
                :disabled="!tempCategory.name"
              >
                <v-btn
                  :disabled="!tempCategory.name"
                  :loading="false"
                  class="btn-accept rounded-lg ma-0 contentinfo"
                  @click="addNewCategory"
                >
                  <v-icon>mdi-save</v-icon>
                  ایجاد دسته‌بندی
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-add-new-category`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="ایجاد دسته‌بندی"
                />
              </div>
            </v-card-actions>
          </v-card>
        </custom-popup>

        <edit-appointment-dates
          v-if="
            computedValue &&
            computedValue[this.getItemsReservations] &&
            computedValue[this.getItemsReservations].length
          "
          ref="app-dates"
          v-model="editDialog"
          :category-id="value && value.id ? value.id : undefined"
          :dates.sync="computedValue[this.getItemsReservations]"
          :tabs.sync="tabs"
        />

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" v-if="!isCategoryMode">
            <v-btn block color="success" outlined @click="dialog = true">
              <v-icon>mdi-plus</v-icon>
              افزودن تاریخ جدید
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-new-date`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن تاریخ جدید"
            />
          </div>
          <div class="rowinfo" v-else>
            <v-btn
              block
              color="success"
              outlined
              @click="handleCategoryMode(true)"
            >
              <v-icon>mdi-plus</v-icon>
              افزودن دسته‌بندی جدید
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-new-category`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن دسته‌بندی جدید"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import CustomDatePicker from "@/view/content/custom-date-picker.vue";
import PriceInput from "@/core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import EditAppointmentDates from "@/view/pages/otherQrTypes/appointment/cm/editAppointmentDates.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";

const EditAppointmentCategory = () =>
  import(
    "@/view/pages/otherQrTypes/appointment/cm/editAppointmentCategory.vue"
  );

export default {
  name: "Appointments",

  components: {
    PicSelector,
    EditAppointmentCategory,
    EditAppointmentDates,
    PriceInput,
    CustomDatePicker,
  },

  props: {
    value: Object,
    onlyAppointments: Boolean,
    // category: [Object, Array]
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "appointment-q",
      cons: {
        title: "افزودن / ویرایش تاریخ و نوبت‌ها",
        buttons: [{ type: "submit", handler: () => this.createAppointments() }],
      },
      createCategoryDialog: false,
      categoryModeLoading: false,
      dialog: false,
      editDialog: false,
      tabs: 0,
      tempContent: [],
      loading: false,
      dates: [],
      shiftTimes: [{ start: "", end: "" }],
      title: "ساعت",
      interval: "",
      count: 30,
      price: "",
      appointmentsOfDates: [],
      isCategoryMode: false,
      // resCategories: [],
      tempCategory: {
        old_appointments: undefined,
        name: "",
        picture: "",
        qr_id: "",
      },
    };
  },

  mounted() {
    this.onlyAppointments
      ? (this.computedValue[this.getItemsReservations] = this.initTimes(
          this.value.reservations
        ))
      : this.getCategories();
  },

    computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    getItemsReservations() {
      return !this.onlyAppointments ? "items" : "reservations";
    },
    minDate() {
      const moment = require("moment-jalaali");
      return moment().format("jYYYY-jMM-jDD");
    },
    maxDate() {
      const moment = require("moment-jalaali");
      return moment().add(30, "d").format("jYYYY-jMM-jDD");
    },
    computedDate() {
      return this.dates?.map((item) => {
        const moment = require("moment-jalaali");
        const normalizedItem = item.replace(/\//g, "-");
        
        const m = moment(normalizedItem, "jYYYY-jMM-jDD");
        
        return {
          text: m.format("dddd") + " " + m.format("jYYYY/jMM/jDD"), 
          value: m.format("YYYY-MM-DD"), 
          name: m.format("dddd"),
        };
      });
    },
    canSubmit() {
      return (
        !!this.dates?.length &&
        !!this.shiftTimes?.length &&
        !!this.title &&
        !!this.interval &&
        !!this.count
      );
    },
  },


  methods: {
    getCategories() {
      this.loading = true;

      this.$api
        .get("/category-reservation", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => {
          if (!!data.data?.length) {
            this.isCategoryMode = true;
            // this.resCategories = data.data;
            try {
              this.computedValue[this.getItemsReservations] = data.data.map(
                (item) => ({
                  ...item,
                  reservations: this.initTimes(item.reservations),
                })
              );
            } catch (e) {
              console.log(e);
            }
          } else {
            this.fetch();
            this.isCategoryMode = false;
            // this.resCategories = []
          }
        })
        .catch(({ response }) => {
          console.log("failed to load reservation categories: ", response);
          this.fetch();
        });
    },
    fetch() {
      this.$api
        .get("/v1/testQr/reservation/list", {
          params: {
            qr_id: this.createQrID,
            category_id: this.value?.id ?? undefined,
          },
        })
        .then(
          ({ data }) =>
            (this.computedValue[this.getItemsReservations] = this.initTimes(
              data.data
            ))
        )
        .finally(() => (this.loading = false));
    },
    initTimes(data) {
      return data.reduce((acc, curr) => {
        // Find if an entry with the same text, value, and name already exists
        let existingEntry = acc.find((item) => item.value === curr.value);

        // If it doesn't exist, create a new entry
        if (!existingEntry) {
          existingEntry = {
            text: curr.text,
            value: curr.value,
            name: curr.name,
            qr_id: curr.qr_id,
            times: [],
          };

          acc.push(existingEntry);
        }

        // Add the time-specific data to the times array
        existingEntry.times.push({
          title: curr.title,
          description: curr.description,
          time: curr.reserve_time.split(" ")[1].slice(0, 5), // Extract time part
          price: curr.price, // Convert price to number
          discount: curr.discount.toString(), // Convert discount to string
          details: JSON.parse(curr.details), // Convert details to array
          status: curr.status || "notReserved",
          id: curr.id,
        });

        return acc;
      }, []);
    },
    addShift() {
      let end = this.shiftTimes.at(-1).end;

      const moment = require("moment");
      this.shiftTimes.push({
        start: moment(end, "HH:mm").add(10, "m").format("HH:mm"),
        end: moment(end, "HH:mm").add(1, "h").format("HH:mm"),
      });
    },
    editDates(index) {
      this.tabs = index;
      // this.tempContent = JSON.parse(JSON.stringify(this.computedValue[this.getItemsReservations]))
      // this.tabs = index;
      this.editDialog = true;
    },
    createAppointments() {
      if (!this.canSubmit)
        return this.$toast.error("مقادیر را به درستی وارد نمایید!");
      this.dialog = false;
      let arr = this.value[this.getItemsReservations];

      const moment = require("moment");

      // Iterate through each shift and generate times
      let times = [];
      this.shiftTimes.forEach((shift, index) => {
        let start = moment(shift.start, "HH:mm");
        let end = moment(shift.end, "HH:mm");
        let diff = end.diff(start, "hours", true);
        let add = 0;

        for (let i = 0; i < this.count; i++) {
          times.push({
            title: this.title,
            description: "",
            time: moment(start).add(add, "m").format("HH:mm"),
            price: this.price,
            discount: "0",
            details: [],
            status: "notReserved",
          });
          add += !!Number(this.interval)
            ? Number(this.interval)
            : (diff / this.count) * 60;

          if (
            !!i &&
            moment(times[times.length - 1].time, "HH:mm").isAfter(
              moment(end).subtract((diff / this.count) * 60, "m")
            )
          )
            break;
        }
      });

      // Add times to each selected date
      this.computedDate.forEach((item) => {
        arr.push({
          ...item,
          ...(this.onlyAppointments &&
            this.value && { res_category_id: this.value.id }),
          times: JSON.parse(JSON.stringify(times)),
        });
      });

      this.computedValue[this.getItemsReservations] = arr;
      this.$nextTick(() => {
        this.dates = [];
        this.shiftTimes = [{ start: "", end: "" }];
        this.title = "ساعت";
        this.interval = "";
        this.count = 30;
        this.price = "";

        this.$refs["app-dates"].submitAppointments();
      });
    },
    async deleteDate(date, index) {
      if (await this.$modal.yesNo("حذف تمام نوبت‌های موجود در این تاریخ؟")) {
        this.loading = true;

        this.$api
          .delete("/v1/testQr/reservation/date/delete", {
            params: {
              qr_id: this.createQrID,
              date: date.value,
            },
          })
          .then(({ data }) => console.log("deleted: ", data))
          .catch(({ response }) =>
            console.log("failed to delete appointment date: ", response)
          )
          .finally(() => (this.loading = false));

        this.computedValue[this.getItemsReservations].splice(index, 1);
      }
    },
    async handleCategoryMode(add = false) {
      console.log("add: ", add);

      if (add) {
        if (this.computedValue?.hasOwnProperty("items"))
          this.$nextTick(() => {
            this.isCategoryMode = false;
            this.$forceUpdate();
          });

        this.createCategoryDialog = true;
      } else {
        this.$nextTick(() => {
          this.isCategoryMode = true;
          this.$forceUpdate();
        });

        if (
          await this.$modal.yesNo(
            "همه دسته‌بندی‌ها حذف می‌شود! آیا ادامه می‌دهید؟"
          )
        ) {
          this.categoryModeLoading = true;

          this.$api
            .delete("/v1/testQr/category-reservation/delete-all", {
              params: {
                qr_id: this.createQrID,
              },
            })
            .then(({ data }) => {
              this.getCategories();
              this.$toast.success("با موفقیت تغییر یافت");
            })
            .catch(({ response }) =>
              console.log("failed to disable category mode: ", response)
            )
            .finally(() => (this.categoryModeLoading = false));
        }
      }
    },
    addNewCategory() {
      if (
        !this.isCategoryMode &&
        !this.tempCategory.old_appointments &&
        !!this.computedValue[this.getItemsReservations]?.length
      )
        return this.$toast.warning(
          "گزینه تغییر به حالت دسته‌بندی انتخاب نشده است!",
          { timeout: 4000 }
        );
      else if (this.isCategoryMode) delete this.tempCategory.old_appointments;

      this.loading = true;

      this.$api
        .post("/v1/testQr/category-reservation", {
          ...this.tempCategory,
          qr_id: this.createQrID,
        })
        .then(({ data }) => {
          this.getCategories();
          this.$toast.success("دسته‌بندی با موفقیت ایجاد شد.");

          this.createCategoryDialog = false;
          this.tempCategory = {
            name: "",
            picture: "",
            qr_id: "",
          };
        })
        .catch(({ response }) => {
          console.log("failed to add new reservation category: ", response);
          this.$toast.error("خطا در ایجاد دسته‌بندی!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
